import {
    AfterContentChecked,
    AfterContentInit,
    AfterViewInit,
    Component,
    NgModule,
    OnInit,
    ViewChild,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Headers, RequestOptions } from '@angular/http';
import { ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ConstantComponent } from "app/constant.component";
import { LoginService } from "app/login/login.service";
import previousActionStatusOfLicense from "./../Master/Subscriber/TypeScript/LicenseStatusConstant";
import { CommanService } from 'app/shared/comman/comman.service';
import {formatDate} from '@angular/common';
import * as moment from 'moment';
@Component({
    selector: "app-service-list",
    templateUrl: "./service-list.component.html",
    styleUrls: ["./service-list.component.scss"],
    providers: [LoginService],
})
@NgModule({
    imports: [FormsModule, ReactiveFormsModule],
})
export class ServiceListComponent implements OnInit {
    // confirm_password_Text: "";
    // new_password_Text: "";
    usernameLogged:any = "";
    UserId:any;
    UserRoleName:any = "";
    companyName:any = "";
    subscriberNameLogged:any = "";
    showForgotpassSuccess = false;
    showForgotpassError = false;
    isFromForgotPasswordScreen = false;
    ProductListForSubscriber=[]
    previousActionStatusOfLicense = previousActionStatusOfLicense
    services = [];
    currentDate1: any;
    constructor(
        private modalService: NgbModal,
        private service: LoginService,
        private activatedRoute: ActivatedRoute,
        private comman : CommanService 
    ) {
        this.showForgotpassSuccess = false;
        this.showForgotpassError = false;
    }
    @ViewChild("ChangePasswordContent") ChangePasswordContent;
    moduleDetails:any=[]
    ngOnInit() {
        this.addBgClass()
        localStorage.setItem('ModuleId','0')
       this.currentDate1 = formatDate(new Date(), 'yyyy-MM-ddT00:00:00','en-in').toString(); 
       console.log(this.currentDate1)
       localStorage.removeItem('DynamicMenuList');
        this.UserId = localStorage.getItem('userIdLogged')
        this.usernameLogged = localStorage.getItem('usernameLogged')
        this.UserRoleName= localStorage.getItem('UserRoleName')
        this.companyName=localStorage.getItem('companyName')
        this.subscriberNameLogged = localStorage.getItem('subscriberNameLogged')
        // this.activatedRoute.queryParams.subscribe((data) => {
        //     this.isFromForgotPasswordScreen = data.fromForgotPasswordScreen;
        //     if (data.fromForgotPasswordScreen == 'true') {
        //         console.log(this.isFromForgotPasswordScreen);
        //         this.showDemoModal(this.ChangePasswordContent);
        //     }
        // });
        // localStorage.getItem('resetPasswordFlag')
        // if(localStorage.getItem('resetPasswordFlag')== 'true'){
        //     this.showDemoModal(this.ChangePasswordContent);
        // }
        // this.services = ConstantComponent.IframesOfServices;
        // this.getAssignedProductsByUserID(10984)
        this.service
        .get(ConstantComponent.CloudUrl + "/Users/UserAPI/GetAllModuleDetails")
        .subscribe(data=>
            {
            this.moduleDetails = data;
            });
            this.getMenuListByModuleID(0)
        this.getAssignedProductsByUserID(ConstantComponent.userIdLogged)
    }
    gotoService(module) {
        // console.log(module.moduleDetailsId);
        // ConstantComponent.IframesOfServices 
        // let SelectedModule = ConstantComponent.ModuleDetailsWithURLS.filter(moduleItem=>{
        //     return moduleItem.moduleDetailsId == module.moduleDetailsId
        // })
              console.log(localStorage.getItem('DynamicMenuList'))
        let SelectedModule = this.moduleDetails.filter(moduleItem=>{
            return moduleItem.id == module.moduleDetailsId
        })
        console.log(SelectedModule);
        // window.location.href = SelectedModule[0].URL;
        console.log(JSON.stringify({thisService:SelectedModule[0].name,thisServiceModuleId:SelectedModule[0].id}))
        this.getMenuListByModuleID(SelectedModule[0].id)
        this.comman.postCrossDomainData(JSON.stringify({thisService:SelectedModule[0].name,thisServiceModuleId:SelectedModule[0].id}),'ifr_mdm')
        if(SelectedModule[0].id == 13)
        {

            this.comman.postCrossDomainData(JSON.stringify({thisService:SelectedModule[0].name,thisServiceModuleId:SelectedModule[0].id}),'ifr_tyre')
        }
        else if(SelectedModule[0].id == 4)
        {
            this.comman.postCrossDomainData(JSON.stringify({thisService:SelectedModule[0].name,thisServiceModuleId:SelectedModule[0].id}),'ifr_cn')
        }
        // else
        // {
           
        // }
      
    }
    onContextMenu(e,module){
        // let SelectedModule = ConstantComponent.ModuleDetailsWithURLS.filter(moduleItem=>{
        //     return moduleItem.moduleDetailsId == module.moduleDetailsId
        // })
        let SelectedModule = this.moduleDetails.filter(moduleItem=>{
            return moduleItem.id == module.moduleDetailsId
        })
        console.log(SelectedModule);
        console.log(JSON.stringify({thisService:SelectedModule[0].name,thisServiceModuleId:SelectedModule[0].id}))
        localStorage.setItem("thisService",SelectedModule[0].name)
        localStorage.setItem("thisServiceModuleId",SelectedModule[0].id)
        this.comman.postCrossDomainData(JSON.stringify({thisService:SelectedModule[0].name,thisServiceModuleId:SelectedModule[0].id}),'ifr_mdm')
        
    }
    mouseover(e,module){
        
        // let SelectedModule = ConstantComponent.ModuleDetailsWithURLS.filter(moduleItem=>{
        //     return moduleItem.moduleDetailsId == module.moduleDetailsId
        // })
        let SelectedModule = this.moduleDetails.filter(moduleItem=>{
            return moduleItem.id == module.moduleDetailsId
        })
        console.log(SelectedModule[0].moduleURL)
  
            e.target.setAttribute("href",
            `javascript:setTimeout(function(){window.location = '${SelectedModule[0].moduleURL.toString()}' },500);`)
    }

    showDemoModal = function async (content) {
        setTimeout(() => {
            console.log(content);
            var that = this;
            this.modalService.open(content, { size: "lg" }).result.then(
                (result) => {
                    console.log("result")
                    console.log(result)//0
                    // bootbox.alert("Please Change he password,")
                    this.closeResult = `Closed with: ${result}`;
                    that.showForgotpassSuccess = false;
                    that.showForgotpassError = false;
                },
                (reason) => {
                    console.log('reason')
                    console.log(reason)//Cross click
                    // if(reason == "fogotpasswordsuccess"){}
                    this.closeResult = `Dismissed ${this.getDismissReason(
                        reason
                    )}`;
                    that.showForgotpassSuccess = false;
                    that.showForgotpassError = false;
                }
            );
        }, 300);
    };

    getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    submitChangePasswordRequest(value) {
        console.log(value);
        this.service
            .create(
                ConstantComponent.CloudUrl + "/Users/UserAPI/ChangePassword",
                { UserId:localStorage.getItem("userIdLogged"),Password: value.confirm_password }
            )
            .subscribe(
                (data: any) => {
                    console.log(data);
                    if (data.isSuccess) {
                        // this.router.navigate(["login"], {
                        //     queryParams: { forgotpas: true },
                        // });
                        // setTimeout(() => {
                        // }, 2000);
                        bootbox.alert("Successfully Changed Password");
                        this.modalService.dismissAll("fogotpasswordsuccess");
                        this.showForgotpassSuccess = true;
                        localStorage.setItem('resetPasswordFlag','false')
                    }
                },
                (error: any) => {
                    console.log("this", error.errors);
                    this.showForgotpassError = true;
                }
            );
    }
    getAssignedProductsByUserID =  (userId)=>{
    this.service
        .get(ConstantComponent.CloudUrl + "/User/UserObjectConstraintMappingAPI/GetUserObjectConstraintMappingByUserId/" + userId)
        .subscribe(
            async (data: any) => {
                this.services = data;
                this.services = this.services.filter(d=>d.subscriberMasterId == ConstantComponent.subscriberIdLogged)
                console.log(this.services)
                for (let i = 0; i < this.services.length; i++) {
                    const element = this.services[i];
                    console.log(element)
                    this.services[i] = await this.getLicenseDetailsBySubscriber(
                        element
                    );
                }
            },
            (error: any) => {
                console.log("this", error.errors);
                bootbox.alert("Something went wrong!");
            }
        );
    }


    getLicenseDetailsBySubscriber = async (moduleDetail)=>{
        // console.log(moduleDetail)
        let data: any = await this.service
            .get(ConstantComponent.CloudUrl + "/Subscriber/SubscriberLincenseAPI/GetLicenseBySubscriberId/" + ConstantComponent.subscriberIdLogged)
            .toPromise();

        for (let i = 0; i < data.length; i++) {
            console.log("before:"+data[i].licenseValidUpTo)
            if(data[i].isGraceAllowed==true)
            {
                let dt = new Date(data[i].licenseValidUpTo);
                dt.setDate(dt.getDate() + data[i].licenseGracePeriod);
       
               data[i].licenseValidUpTo = formatDate(dt, 'yyyy-MM-ddT00:00:00','en-in').toString();
             
                //       let ds = data[i].licenseValidUpTo.getDate()
                // data[i].licenseValidUpTo.setDate(ds + data[i].licenseGracePeriod);
            }
             console.log("after:"+data[i].licenseValidUpTo)
            const element = data[i];

            if(element.moduleDetailsId  == moduleDetail.moduleDetailsId){
                // console.log(element);
                moduleDetail = { ...moduleDetail, ...element };
            }
        }
        // console.log(moduleDetail);
        // if(!moduleDetail['licenseName']){
        //     moduleDetail['licenseName'] = "No license"
            
        // }
        return moduleDetail;
    }


    addBgClass = function () {
        // $('body').addClass('bg-color-class');
        $('body').addClass('bg-color-class-green-gradient');
    }
    // To calculate the no. of days between two dates
    getLicenseExpireInDays = (validUpToDate: Date) => {
        validUpToDate = new Date(validUpToDate) 
        let currentDate: Date = new Date(new Date().toISOString()); 

        var Difference_In_Time =
            validUpToDate.getTime() - currentDate.getTime();
             
        let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        console.log( Difference_In_Days)
        return (Number(Difference_In_Days.toPrecision(1)));
        // return Math.abs(Number(Difference_In_Days.toPrecision(1)));
    };
    getLicenseStartInDays = (startDate: Date) => {
        startDate = new Date(startDate)
        let currentDate: Date = new Date(new Date().toISOString());

        var Difference_In_Time =
            startDate.getTime() - currentDate.getTime();

        let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        console.log( Difference_In_Days)
        return parseInt((Difference_In_Days.toPrecision(1)));
        // return Math.abs(Number(Difference_In_Days.toPrecision(1)));
    };

    
    onLoggedout() {
        let headers = new Headers({
            "Content-Type": "application/json; charset=UTF-8",
        });
        let options = new RequestOptions({ headers: headers });
        //Add UserSessionMapping Details in Object
        let UserSessionDetails: any = {};
        UserSessionDetails.UserId = ConstantComponent.userIdLogged;
        UserSessionDetails.UserSessionId = ConstantComponent.UserSessionId;
        UserSessionDetails.FormId = 0;
        UserSessionDetails.IpAddress = ConstantComponent.IpAddress;
        UserSessionDetails.BrowserName = ConstantComponent.BrowserName;
        UserSessionDetails.BrowserVersion = ConstantComponent.BrowserVersion;

        this.service
            .update(ConstantComponent.CloudUrl + "/Users/UserAPI/LogOut/" + parseInt(localStorage.getItem("userIdLogged")),UserSessionDetails)
            .subscribe(
                (data: any) => {
                    if (data.isSuccess == true) {
                        localStorage.clear();
                        this.comman.clearLocalStorageOfAllServices();
                    }
                },
                (error) => {
                    // bootbox.alert("Something went wrong! Please try again")
                }
            );
    }


    getMenuListByModuleID = async (moduleId) => {
        console.log(moduleId)
        let data: any = await this.service.get(ConstantComponent.CloudUrl + '/Users/MenuAPI/GetDynamicMenuList/' + ConstantComponent.subscriberIdLogged + '?UserId=' + ConstantComponent.userIdLogged +'&moduleDetailsId='+moduleId).toPromise()
        console.log(data);
        if(moduleId != 0)
        {
            let module = this.moduleDetails.filter(item=>{
                return item.id == moduleId  
            })
    
            let ifrModule=ConstantComponent.IframesOfServices.filter((item:any)=>{
                return module[0].name.toLowerCase() == (item.service).toLowerCase();
            });
            // localStorage.removeItem('DynamicMenuList')
            localStorage.setItem('ModuleId',moduleId)
            localStorage.setItem('DynamicMenuList',JSON.stringify(data))
            console.log(localStorage)
            this.comman.postCrossDomainData(JSON.stringify({DynamicMenuList:data}),ifrModule[0].id)
            this.comman.postCrossDomainData(JSON.stringify({DynamicMenuList:data}),'ifr_mdm')
        }
        else
        {
            localStorage.setItem('ModuleId','0')
            localStorage.setItem('DynamicMenuList',JSON.stringify(data)) 
            let localStrgKeys = JSON.parse(JSON.stringify(localStorage));
            let testObj = {};
            Object.keys(localStrgKeys).forEach((key) => {
                // console.log(localStorage.getItem(key))
                console.log(key, localStrgKeys[key]);
                testObj[key] = localStrgKeys[key];
            });
            ConstantComponent.IframesOfServices.forEach((service:any,idx)=>{
                this.comman.postCrossDomainData(JSON.stringify(testObj),service.id);
                // we should not parse inner value of any key in the cros domin store script
            })
            // window.location.reload()
        }

    }
}
